import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { MessageCircleIcon, PhoneIcon, XIcon } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { business } from '../data/business';
export function FloatingActions() {
  const {
    t
  } = useLanguage();
  const [bubble, setBubble] = useState(true);
  return <div className="fixed bottom-5 right-4 z-40 flex flex-col items-end gap-3 sm:bottom-6 sm:right-6" data-id="element-122" data-mp="gbicapbqmwh">
      <AnimatePresence data-id="element-123" data-mp="5fxxipopqd7x">
        {bubble && <motion.div initial={{
        opacity: 0,
        y: 8,
        scale: 0.96
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 8,
        scale: 0.96
      }} transition={{
        duration: 0.2,
        ease: [0.23, 1, 0.32, 1]
      }} className="flex max-w-[16rem] items-start gap-2 rounded-lg bg-white px-3.5 py-2.5 shadow-lift" data-id="element-124" data-mp="9e5dhibcrai2">
            <a href={business.whatsappHref} target="_blank" rel="noreferrer" className="text-sm font-medium leading-snug text-navy" data-id="element-125" data-mp="2l47luv4gz0au">
              💬 {t.floating.whatsapp}
            </a>
            <button type="button" onClick={() => setBubble(false)} aria-label={t.floating.close} className="-mr-1 -mt-1 rounded p-1 text-ink/40 transition-colors duration-150 hover:text-navy" data-id="element-126" data-mp="ba18ejb91esm">
              <XIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-127" data-mp="yzvmf47b19eg" />
            </button>
          </motion.div>}
      </AnimatePresence>

      <div className="flex items-center gap-3" data-id="element-128" data-mp="tzr3z8mu64ll">
        <a href={business.phoneHref} aria-label={`${t.floating.call} ${business.phoneDisplay}`} className="flex h-12 w-12 items-center justify-center rounded-full bg-navy text-white shadow-lift transition-colors duration-150 hover:bg-navy-700 sm:hidden" data-id="element-129" data-mp="pzgz5zas5k8b">
          <PhoneIcon className="h-5 w-5" aria-hidden="true" data-id="element-130" data-mp="35r4vbshyz8q2" />
        </a>
        <a href={business.whatsappHref} target="_blank" rel="noreferrer" aria-label={t.floating.whatsapp} className="flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-lift transition-transform duration-150 hover:scale-105" data-id="element-131" data-mp="378jzksuy38dd">
          <MessageCircleIcon className="h-6 w-6" aria-hidden="true" data-id="element-132" data-mp="328xksezgxk2g" />
        </a>
      </div>
    </div>;
}